<h1 class="strong impersonation-dialog__title" mat-dialog-title>
  {{ 'header.userSettings.impersonation.editImpersonation' | translate }}
</h1>
<div class="impersonation-dialog__content" mat-dialog-content>
  <mat-tab-group (selectedIndexChange)="handleTabChange($event)" mat-stretch-tabs>
    <mat-tab label="{{ 'header.userSettings.impersonation.impersonatingUsers' | translate }}">
      <div class="impersonation-dialog__add-employee">
        <button class="btn btn-withIcon btn-secondary" (click)="openAssignEmployeeDialog()">
          <span class="icon icon-Plus"></span>
          <span>{{ 'header.userSettings.impersonation.assignEmployee' | translate }}</span>
        </button>
      </div>
      @if (isLoading$() === false) {
        <app-table [columns]="impersonationColumns" [data]="impersonatingUsers()" [isTableInsideDialog]="true" />
      } @else {
        <app-loading [loadingMode]="LoadingMode.TABLE" />
      }
    </mat-tab>
    <mat-tab label="{{ 'header.userSettings.impersonation.imitableUsers' | translate }}">
      @if (isLoading$() === false) {
        <app-table [columns]="impersonationColumnsWithoutDelete" [data]="imitableUsers" [isTableInsideDialog]="true" />
      } @else {
        <app-loading [loadingMode]="LoadingMode.TABLE" />
      }
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button class="btn btn-secondary" (click)="closeWindow()">
    {{ 'default.cancel' | translate }}
  </button>
  <button class="btn btn-primary" (click)="save()">
    {{ 'default.save' | translate }}
  </button>
</div>
